import {sendPostRequest, sendPutRequest, sendDeleteRequest} from '../requests';

type CreateTenantProps = {
  name: string,
  slug: string,
  industryCode: string
}

type UpdateTenantProps = {
  name: string,
}

const baseUrl = '/tenants';

export const addTenant = (data: CreateTenantProps) =>
  sendPostRequest(baseUrl, data);

export const updateTenantById = (id: string, body: UpdateTenantProps) =>
  sendPutRequest(`${baseUrl}/${id}`, body);

export const freezeTenantById = (id: string) =>
  sendDeleteRequest(`${baseUrl}/${id}`);
